import React from 'react';
import { Box } from '@mui/material';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';

interface DataTableProps extends DataGridProps {
  title?: string;
  height?: string | number;
}

const DataTable: React.FC<DataTableProps> = ({ 
  title, 
  height = '100%', 
  sx,
  ...dataGridProps 
}) => {
  const defaultSx = {
    '& .MuiDataGrid-root': {
      border: 'none',
      backgroundColor: '#FAFAFA', // Very light gray background for better contrast
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid #C0C0C0', // CharcoalMediumBrush
      flex: 1,
      color: '#000000 !important', // Black text for maximum contrast
      backgroundColor: '#FAFAFA', // Very light gray for better contrast
      '& .MuiTypography-root': {
        color: '#000000 !important', // Ensure all typography in cells is black
      },
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#F5F5F5', // Lighter gray for better contrast
      borderBottom: '2px solid #C0C0C0', // CharcoalMediumBrush
      color: '#000000 !important', // Black text for maximum contrast
      '& .MuiTypography-root': {
        color: '#000000 !important', // Ensure all typography in headers is black
      },
    },
    '& .MuiDataGrid-row': {
      backgroundColor: '#FAFAFA', // Very light gray for better contrast
      '&:hover': {
        backgroundColor: '#F0F0F0', // Slightly darker on hover
      },
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #C0C0C0', // CharcoalMediumBrush
      color: '#000000', // TextPrimaryBrush
      backgroundColor: '#FAFAFA', // Very light gray
    },
    '& .MuiDataGrid-columnHeader': {
      flex: 1,
    },
  };

  return (
    <Box sx={{ 
      flex: 1, 
      width: '100%', 
      height, 
      display: 'flex', 
      flexDirection: 'column',
      minWidth: 0, // Prevent flex item from overflowing

    }}>
      <DataGrid
        {...dataGridProps}
        sx={{
          ...defaultSx,
          width: '100% !important',
          minHeight: '400px',
          flex: 1,
          '& .MuiDataGrid-root': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-main': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-virtualScroller': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-virtualScrollerContent': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-virtualScrollerRenderZone': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-columnHeaders': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-columnHeader': {
            minWidth: 0,
          },
          '& .MuiDataGrid-columnHeadersInner': {
            width: '100% !important',
            minWidth: 0,
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            width: '100% !important',
            minWidth: 0,
          },
          ...(sx || {}),
        }}
        density="compact"
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default DataTable;
